import { Component } from '@angular/core';

@Component({
  selector: 'app-omnisearch-page',
  template: '',
})
export class OmnisearchPageComponent {}
